import moment from "moment";
import type { Moment } from "moment";

/**
 * Преобразование fromDate и toDate к Moment
 */

interface Dates {
  fromDate?: string;
  toDate?: string;
}

export const toMomentObjectDates = <T extends Dates>(record: T) => {
  const fromDate = record.fromDate ? moment(record.fromDate) : undefined;
  const toDate = record.toDate ? moment(record.toDate) : undefined;
  return { ...record, fromDate, toDate };
};
